import { useTranslation } from "react-i18next";
import { AddressOption, Partner } from "~/common/props/orchestrator";
import styles from "./detail-profile-data.module.css";

export const DetailProfileData = ({
  partner,
  activeAddresses,
  className




}: {partner: Partner;activeAddresses?: AddressOption;className?: string;}) => {
  const { t } = useTranslation();

  return (
    <div
      className={`${styles.detailProfileDataStyled} ${
      className ? className : ""
      }`}>

      {partner?.description &&
      <div className={`${styles.popupDetailProfileDataItem}`}>
          <span
          className={`${styles.profileDataItemIcon} icon-circle-exclamation`} />

          <div className={`${styles.profileDataItemText}`}>
            <p>{t("detailProfile.about_us")}</p>
            <p>{partner.description}</p>
          </div>
        </div>}

      {partner?.scheduleConfiguration?.resume &&
      <div className={`${styles.popupDetailProfileDataItem}`}>
          <span className={`${styles.profileDataItemIcon} icon-clock`} />
          <div className={`${styles.profileDataItemText}`}>
            <p>{partner.scheduleConfiguration.resume.trim()}</p>
          </div>
        </div>}

      {partner?.country &&
      <div className={`${styles.popupDetailProfileDataItem}`}>
          <span
          className={`${styles.profileDataItemIcon} icon-location-outline`} />

          <div className={`${styles.profileDataItemText}`}>
            <p>
              {partner?.city ? `${partner.city}, ` : ""}
              {partner.country}
            </p>
          </div>
        </div>}

      {partner?.phone &&
      <div className={`${styles.popupDetailProfileDataItem}`}>
          <span className={`${styles.profileDataItemIcon} icon-phone`} />
          <div className={`${styles.profileDataItemText}`}>
            <p>
              {partner.prefixPhone} {partner.phone}
            </p>
          </div>
        </div>}

      {(activeAddresses?.address || partner?.city) &&
      <div className={`${styles.popupDetailProfileDataItem}`}>
          <span className={`${styles.profileDataItemIcon} icon-store`} />
          <div className={`${styles.profileDataItemText}`}>
            <p>{activeAddresses ? activeAddresses?.address : partner?.city}</p>
          </div>
        </div>}

      {partner?.logisticConfiguration?.localLogisticEnabled &&
      <div className={`${styles.popupDetailProfileDataItem}`}>
          <span className={`${styles.profileDataItemIcon} icon-truck`} />
          <div className={`${styles.profileDataItemText}`}>
            <p>
              {`${t(
              "detailProfile.local_shipping"
            )} ${partner?.logisticConfiguration?.localAvailabilityCities?.join(
              ", "
            )}`}
            </p>
          </div>
        </div>}

      {partner?.logisticConfiguration?.nationalLogisticEnabled &&
      <div className={`${styles.popupDetailProfileDataItem}`}>
          <span className={`${styles.profileDataItemIcon} icon-truck`} />
          <div className={`${styles.profileDataItemText}`}>
            <p>{`${t(
              "detailProfile.national_shipping"
            )} ${partner?.country}`}</p>
          </div>
        </div>}

    </div>);

};